import { Loader } from "@components/loader/loader";
import { useFetchArtists } from "@hooks/use_fetch_artists";
import * as types from "@root/types";
import { isEmpty } from "@services/helpers";
import { isNil } from "@services/typed_helpers";
import React, { type FC, type ReactNode } from "react";

interface EntryProps {
  artist: types.Artist;
}

const LinkEntry: FC<EntryProps> = ({ artist }) => {
  const nameId = `name-${artist.login}`;
  const studioNumberId = artist.studioNumber ? `studio-${artist.login}` : "";

  return (
    <a
      className="artists-roster--column-entry"
      href={`/artists/${artist.login}`}
      aria-labelledby={`${nameId} ${studioNumberId}`}
    >
      <div id={nameId} className="artists-roster--column-entry--name">
        <span>{artist.name}</span>
      </div>
      {artist.studioNumber ? (
        <div
          id={studioNumberId}
          className="artists-roster--column-entry--studio"
        >
          <span>, {artist.studioNumber}</span>
        </div>
      ) : null}
    </a>
  );
};

export const ArtistRoster: FC = () => {
  const { artists, loading } = useFetchArtists();

  let content: ReactNode;

  if (loading) {
    content = <Loader />;
  } else if (!isNil(artists) && !isEmpty(artists)) {
    content = (
      <div className="artists-roster--column">
        {artists.map((artist) => (
          <LinkEntry artist={artist} key={artist.login} />
        ))}
      </div>
    );
  }
  return <article className="artists-roster--columns">{content}</article>;
};
